import styled from 'styled-components';
import palette from '../../../lib/styles/palette';
import { useRef, useState, useEffect, useCallback } from 'react';

import { MdExpandMore, MdExpandLess, MdRemoveCircleOutline, MdAdd } from 'react-icons/md';
// import ActionButtons from '../ActionButtons';
// import AskCancelModal from '../AskCancelModal';

import { standardWeight_Overbridge } from '../../../lib/data/standard-weight';

const OverbridgeForm = ({ onSaveStructure, onChangeWeightSummary, overbridges, beltWidth, horizontalLength }) => {
    const [isShow, setIsShow] = useState(overbridges?.length || false);
    const [newOverbridge, setNewOverbridge] = useState(overbridges || []);
    const [factor, setFactor] = useState('');
    const [id, setId] = useState('');
    // const [length, setLength] = useState('');
    const [standardWeight, setStandardWeight] = useState('');
    const [qty, setQty] = useState(Math.ceil(horizontalLength / 100));
    const [unitWeight, setUnitWeight] = useState('');
    const [weight, setWeight] = useState('');
    const [totalQty, setTotalQty] = useState('');
    const [totalWeight, setTotalWeight] = useState('');
    // const [modal, setModal] = useState(false);
    /* 변경사항을 저장했었는지 여부에 대한 상태 저장 */
    const [isChanged, setIsChanged] = useState(false);

    /*  처음 props로 넘어온 overbridges를 초기값 그대로 보관하고 있다가 취소 버튼을 눌렀을 때 원상 복귀 시키기 위해
        useRef를 사용하여 저장해 둔다. */
    const initialoverbridge = useRef(overbridges || []);

    /* 벨트폭에 해당하는 Weight를 가져온다. */
    useEffect(() => {
        if (!standardWeight_Overbridge || !beltWidth) return;
        const library = standardWeight_Overbridge.find((item) => item.beltWidth === parseInt(beltWidth));
        if (!library) {
            alert('Check Belt Width!!');
            return;
        }
        setStandardWeight(library.standardWeight);
    }, [beltWidth, horizontalLength]);

    /* 수량 계산 */
    // useEffect(() => {
    //     // console.log('horizontalLength : ', horizontalLength);
    //     if (!horizontalLength) {
    //         return;
    //     }

    //     const _qty = Math.ceil(horizontalLength / 100);
    //     setQty(_qty);
    // }, [horizontalLength]);

    /* 단위 중량 및 중량 자동 계산 */
    useEffect(() => {
        // if (!standardWeight || !factor || !qty) {
        //     return;
        // }
        const _unitWeight = Math.ceil(standardWeight * factor);
        const _weight = Math.ceil(_unitWeight * qty);
        setUnitWeight(_unitWeight);
        setWeight(_weight);
    }, [factor, qty, standardWeight]);

    /* 마지막 ID 가져오기 함수 */
    const getLastId = useCallback(() => {
        if (!newOverbridge.length) {
            return 0;
        }
        return Math.max(...newOverbridge.map((item) => Number(item.id.substring(3))), 0);
    }, [newOverbridge]);

    /* 입력 후 폼 초기화 함수 */
    const initializeForm = useCallback(() => {
        setId(`OB-${getLastId() * 1 + 1}`);
        // setStandardWeight('');
        // setFactor('');
        // setQty('');
        setUnitWeight('');
        setWeight('');
    }, [getLastId]);

    /* 전체 수량 계산 함수 */
    const getTotalQty = useCallback((items) => {
        const _totalQty = items.reduce((accumulator, currentValue) => {
            return accumulator + parseInt(currentValue.qty);
        }, 0);
        setTotalQty(_totalQty);
    }, []);

    /* 전체 중량 계산 함수 */
    const getTotalWeight = useCallback((items) => {
        const _totalWeight = items.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.weight;
        }, 0);
        setTotalWeight(_totalWeight);
    }, []);

    /* 추가 버튼을 누르면 newOverbridge에 overbridge 추가 */
    const onAddOverbridge = useCallback(() => {
        if (!qty || !unitWeight || !weight) {
            alert('Check input(s) before saving!!!');
            return;
        }
        const overbridge = {
            id,
            standardWeight,
            factor,
            qty,
            unitWeight,
            weight,
        };
        setNewOverbridge((prev) => [...prev, overbridge]);
        setIsChanged(true);
    }, [factor, id, qty, standardWeight, unitWeight, weight]);

    /* 삭제 버튼을 누르면 해당 overbridge 삭제 */
    const onDeleteOverbridge = useCallback((id) => {
        setNewOverbridge((prev) => prev.filter((overbridge) => overbridge.id !== id));
        setIsChanged(true);
    }, []);

    /* newOverbridge에 변화가 생기면  리덕스에 변경사항 쓰기 */
    useEffect(() => {
        getTotalQty(newOverbridge);
        getTotalWeight(newOverbridge);
        initializeForm();
        onSaveStructure({
            key: 'overbridge',
            value: newOverbridge,
        });
        onChangeWeightSummary({
            key: 'overbridge',
            value: {
                totalQty,
                totalWeight,
            },
        });
    }, [
        getTotalQty,
        getTotalWeight,
        initializeForm,
        newOverbridge,
        onChangeWeightSummary,
        onSaveStructure,
        totalQty,
        totalWeight,
    ]);

    /* Save 버튼을 누르면 리덕스에 변경사항 쓰기 */
    // const onSaveOverbridge = useCallback(() => {
    //     onSaveStructure({
    //         key: 'overbridge',
    //         value: newOverbridge,
    //     });
    //     onChangeWeightSummary({
    //         key: 'overbridge',
    //         value: {
    //             totalQty,
    //             totalWeight,
    //         },
    //     });
    // }, [newOverbridge, onChangeWeightSummary, onSaveStructure, totalQty, totalWeight]);

    /* 변경 사항을 취소하면 newOverbridge를 초기값으로 변경하고 리덕스에 초기값으로 쓰기 */
    // const onCancelChange = useCallback(() => {
    //     setNewOverbridge(initialoverbridge.current);
    //     onSaveStructure({
    //         key: 'overbridge',
    //         value: initialoverbridge.current,
    //     });
    //     onChangeWeightSummary({
    //         key: 'overbridge',
    //         value: {},
    //     });
    //     setModal(false);
    // }, [onChangeWeightSummary, onSaveStructure]);

    /* Cancel Change 버튼을 눌렀을 때 */
    // const onClickCancel = useCallback(() => {
    //     // 저장된 적이 없다면 alert
    //     if (!isChanged) {
    //         alert('변경내용이 없습니다.');
    //         return;
    //     }
    //     setModal(true);
    // }, [isChanged]);

    return (
        <OverbridgeFormBlock>
            <Title>
                <h3 style={{ width: '400px', margin: '0' }}>Overbridge</h3>
                <div style={{ width: '120px' }}>Q'ty: {totalQty} ea</div>
                <div style={{ width: '170px' }}>Weight: {totalWeight} kg</div>
                <div style={{ fontSize: '1.25rem', fontWeight: 'bold', display: 'flex', alignItems: 'flex-end' }}>
                    {!isShow ? (
                        <MdExpandMore color="orange" onClick={() => setIsShow(true)} />
                    ) : (
                        <MdExpandLess color="orange" onClick={() => setIsShow(false)} />
                    )}
                </div>
            </Title>
            {isShow && (
                <>
                    <table>
                        <thead>
                            <tr>
                                <th>ID.</th>
                                <th>
                                    Standard W't <br />
                                    (kg/m)
                                </th>
                                <th>Factor</th>
                                <th>
                                    Unit W't <br />
                                    (kg/set)
                                </th>
                                <th>Q'ty</th>
                                <th>중량(kg)</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {newOverbridge &&
                                newOverbridge.map((overbridge, index) => (
                                    <tr key={index}>
                                        <td>{overbridge.id}</td>
                                        <td>{overbridge.standardWeight}</td>
                                        <td>{overbridge.factor}</td>
                                        <td>{overbridge.unitWeight}</td>
                                        <td>{overbridge.qty}</td>
                                        <td>{overbridge.weight}</td>
                                        <td className="btn-delete" onClick={() => onDeleteOverbridge(overbridge.id)}>
                                            <MdRemoveCircleOutline />
                                        </td>
                                    </tr>
                                ))}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr className="input-form">
                                {/* <td><StyledInput readOnly value={id} onChange={(e) => setId(e.target.value)} /></td> */}
                                <td className="id-column">{id}</td>
                                <td>{standardWeight}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={factor}
                                        onChange={(e) => setFactor(e.target.value)}
                                    />
                                </td>
                                <td>{unitWeight}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={qty}
                                        onChange={(e) => setQty(e.target.value)}
                                    />
                                </td>
                                {/* <td><StyledInput placeholder="..." value={qty} onChange={(e) => setQty(e.target.value)} /></td> */}
                                {/* <td><StyledInput readOnly value={unitWeight} /></td> */}
                                {/* <td><StyledInput readOnly value={weight}  /></td> */}
                                <td className="total-weight">{weight}</td>
                                <td className="btn-add" onClick={onAddOverbridge}>
                                    <MdAdd />
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={3}>Overbridge Total</td>
                                <td></td>
                                <td>{totalQty}</td>
                                <td>{totalWeight}</td>
                            </tr>
                        </tfoot>
                    </table>
                    {/* <ActionButtons confirmText="Save" cancelText="Cancel Change" onConfirm={onSaveOverbridge} onCancel={onClickCancel} /> */}
                    {/* <AskCancelModal visible={modal} onConfirm={onCancelChange} onCancel={() => setModal(false)} /> */}
                </>
            )}
        </OverbridgeFormBlock>
    );
};

/* =================   Styles   ================== */
const Title = styled.div`
    display: flex;
    align-items: flex-end;
    margin-bottom: 1rem;

    color: ${palette.cyan[6]};
`;

const OverbridgeFormBlock = styled.div`
    // max-width: 1280px;
    // margin: 0 auto;
    // margin: 0 2rem;
    .btn-delete {
        color: ${palette.cyan[6]};
        font-size: 1rem;
        cursor: pointer;
        padding: 0 1rem;
        padding-top: 0.3rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    .btn-add {
        color: ${palette.cyan[6]};
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0;
        padding-top: 0.4rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    table {
        width: 100%;
        font-size: 0.9rem;
        border-collapse: collapse;
    }
    thead {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        color: ${palette.gray[7]};
    }
    tfoot {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        height: 2.5rem;
        font-weight: bold;
        color: ${palette.gray[7]};
    }
    th {
        padding: 0.5rem 0.25rem;
        text-align: center;
    }
    td {
        padding: 0.25rem 0.25rem;
        text-align: center;
    }

    .input-radio {
        display: flex;
        flex-direction: column;
        // margin: 0 1rem;
        align-items: flex-start;
        span {
            margin-left: 0.5rem;
        }
        // 추가함
        label + label {
            margin-top: 0.25rem;
        }
    }
    h3 {
        color: ${palette.cyan[6]};
    }
    .input-form {
        background-color: ${palette.gray[0]};
    }
`;

const StyledInput = styled.input`
    border: none;
    outline: none;
    padding: 0.25rem 0.5rem;
    width: 50px;
    text-align: center;
    background: transparent;
    &:hover {
        background: ${palette.gray[3]};
    }
`;

export default OverbridgeForm;
